import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { BookOpenIcon, XIcon } from 'lucide-react';
const buyers = ['Marcela de Tucumán', 'Jorge de Santa Fe', 'Ana de Rosario', 'Carlos de Córdoba', 'Lucía de Mendoza', 'Martín de Buenos Aires', 'Silvia de Salta'];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentBuyer, setCurrentBuyer] = useState(buyers[0]);
  useEffect(() => {
    const showInterval = setInterval(() => {
      setCurrentBuyer(buyers[Math.floor(Math.random() * buyers.length)]);
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 5000); // Hide after 5 seconds
    }, 15000); // Show every 15 seconds
    // Initial show after 5 seconds
    const initialTimeout = setTimeout(() => {
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 5000);
    }, 5000);
    return () => {
      clearInterval(showInterval);
      clearTimeout(initialTimeout);
    };
  }, []);
  return <AnimatePresence data-id="element-197">
      {isVisible && <motion.div initial={{
      opacity: 0,
      x: -100,
      y: 20
    }} animate={{
      opacity: 1,
      x: 0,
      y: 0
    }} exit={{
      opacity: 0,
      x: -100,
      y: 20
    }} transition={{
      type: 'spring',
      stiffness: 200,
      damping: 20
    }} className="fixed bottom-6 left-6 z-50 bg-white rounded-xl shadow-2xl border border-gray-100 p-4 pr-10 max-w-sm flex items-start gap-4" data-id="element-198">
          <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-gray-400 hover:text-gray-600" data-id="element-199">
            <XIcon className="w-4 h-4" data-id="element-200" />
          </button>

          <div className="bg-primary/10 p-3 rounded-full shrink-0" data-id="element-201">
            <BookOpenIcon className="w-6 h-6 text-primary" data-id="element-202" />
          </div>

          <div data-id="element-203">
            <p className="text-xs font-bold text-gray-500 uppercase tracking-wider mb-1" data-id="element-204">
              Alguien acaba de comprar
            </p>
            <p className="font-bold text-gray-900" data-id="element-205">Administración 360</p>
            <p className="text-sm text-gray-600 mt-1" data-id="element-206">{currentBuyer}</p>
            <p className="text-xs text-gray-400 mt-1" data-id="element-207">Hace unos instantes</p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}